import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updateUserProfileApi } from "../../apis/profile";
import { handleApiError } from "../../helpers";
import { UpdateProfileInterface } from "../../interfaces/profile";
import { fetchUserProfile } from "../../states/action_creators/profile.action_creator";

type formData = {
  first_name: string;
  last_name: string;
};

export const useUpdateUserProfile = () => {
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch()

  const handleUpdateProfile = async (values: formData) => {
    const payload = {} as UpdateProfileInterface;

    payload.firstname = values.first_name;
    payload.lastname = values.last_name;

    try {
      setSubmitting(true);
      const { data } = await updateUserProfileApi(payload);
      dispatch(fetchUserProfile());
      setSubmitting(false);
      toast.success(data.message);
    } catch (error) {
      console.log("ERROR", error);
      toast.error(handleApiError(error));
      setSubmitting(false);
    }
  };

  return { submitting, handleUpdateProfile };
};
